/**
 * Registre des thèmes clients.
 *
 * Chaque thème définit le branding (logo, textes) et les overrides
 * de CSS custom properties à appliquer sur :root via le ThemeProvider.
 *
 * Les clés de `colors` correspondent aux variables CSS définies dans
 * resources/css/app.css (:root { ... }). Seules les variables surchargées
 * doivent être listées — les autres conservent leur valeur par défaut.
 *
 * @see resources/docs/2026-02-17-analyse-theme-switching-par-client.md
 */

export const themes = {
    default: {
        name: 'Horodaty',
        slug: 'default',
        logo: '/assets/images/logo.png',
        logoAlt: 'Horodaty',
        favicon: '/assets/images/favicon.png',
        colors: {
            // Pas de surcharge → utilise les valeurs :root par défaut
        },
        links: {
            website: 'https://horodaty.fr',
            legalNotice: 'https://horodaty.fr/mentions-legales',
            privacyPolicy: 'https://horodaty.fr/politique-de-confidentialite',
            supportEmail: 'support@horodaty.com',
            supportPhone: '09 72 55 22 33',
        },
        storeLinks: {
            appStore: 'https://apps.apple.com/fr/app/horodaty/id6468651158',
            googlePlay: 'https://play.google.com/store/apps/details?id=fr.pmbsoftware.horodatyMobile&hl=fr',
        },
        qrCode: { show: true },
        pages: {
            dashboard: {
                news: {
                    show: true,
                },
            },
            welcome: {
                // Textes traduits — voir locales/<lang>/welcome.json (hero.*)
                titleKey: 'welcome:hero.default.title',
                taglineKey: 'welcome:hero.default.tagline',
            },
        },
    },

    horodateme: {
        name: 'Horodate Me',
        slug: 'horodateme',
        logo: '/assets/images/themes/horodateme/logo.png',
        logoAlt: 'Horodate Me',
        favicon: '/assets/images/themes/horodateme/favicon.png',
        colors: {
            // Les overrides CSS sont dans resources/css/themes/horodateme.css
            // Les couleurs JS ici servent de fallback si le fichier CSS n'est pas chargé
        },
        links: {
            website: 'https://horodateme.fr',
            legalNotice: 'https://horodateme.fr/mentions-legales',
            privacyPolicy: 'https://horodateme.fr/politique-de-confidentialite',
            supportEmail: 'contact@horodateme.com',
        },
        storeLinks: {
            appStore: 'https://apps.apple.com/fr/app/horodateme/id6714477527',
            googlePlay: 'https://play.google.com/store/apps/details?id=fr.pmbsoftware.horodatemeMobile&hl=fr',
        },
        qrCode: { show: false },
        pages: {
            dashboard: {
                news: {
                    show: false,
                },
            },
            welcome: {
                titleKey: 'welcome:hero.horodateme.title',
                taglineKey: 'welcome:hero.horodateme.tagline',
            },
        },
    },
};

/**
 * Récupère la configuration d'un thème par son slug.
 * Retourne le thème par défaut si le slug n'existe pas.
 *
 * @param {string} slug - Identifiant du thème (ex: 'default', 'client-a')
 * @returns {object} Configuration du thème
 */
export function getThemeBySlug(slug) {
    return themes[slug] ?? themes.default;
}

/**
 * Liste tous les slugs de thèmes disponibles.
 *
 * @returns {string[]}
 */
export function getAvailableThemeSlugs() {
    return Object.keys(themes);
}
